import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  static values = {
    useOtpBackupCode: Boolean,
    default: false,
  }

  toggleUseOtpBackupCode(event) {
    event.preventDefault()
    this.useOtpBackupCodeValue = !this.useOtpBackupCodeValue
  }

  useOtpBackupCodeValueChanged() {
    const otpInputName = `user[otp_attempt]`
    const backupCodeInputName = `user[otp_backup_code_attempt]`

    if (this.useOtpBackupCodeValue) {
      this.inputTarget.setAttribute("placeholder", "Unused backup code")
      this.inputTarget.removeAttribute("pattern")
      this.inputTarget.removeAttribute("inputmode")
      this.inputTarget.setAttribute("name", backupCodeInputName)
    } else {
      this.inputTarget.setAttribute("inputmode", "numeric")
      this.inputTarget.setAttribute("pattern", "[0-9]*")
      this.inputTarget.setAttribute("placeholder", "6-digit code")
      this.inputTarget.setAttribute("name", otpInputName)
    }
  }
}
